import { MenuUtils } from './MenuUtils.js';
import { MenuStructure } from '../components/MenuStructure.js';
import { MENU_DEFAULTS } from '../../constants/MenuConstants.js';

export const RecursiveMenuModel = (baseModel, menuConfig, editor) => ({
    defaults: Object.assign({}, baseModel.prototype.defaults, MENU_DEFAULTS, {
        traits: function () {
            return MenuUtils.createInitialTraits(menuConfig);
        },
    }),

    initialize(options) {
        baseModel.prototype.initialize.call(this, options);
        this.menuConfig = menuConfig;
        this.editor = editor;
        this.menuStructure = new MenuStructure(this);

        this.initializeWithDelay();
        this.setupEventListeners();
    },

    initializeWithDelay() {
        setTimeout(() => {
            this.reconstructTraitHierarchy();
            setTimeout(() => {
                this.updateMenuView();
            }, 100);
        }, 300);
    },

    setupEventListeners() {
        this.on('change:traits', () => {
            setTimeout(() => this.updateMenuView(), 50);
        });

        this.on('change:attributes', () => {
            setTimeout(() => this.updateMenuView(), 50);
        });
    },

    getCurrentMenuItems() {
        return MenuUtils.getCurrentMenuItems(
            this.getAttributes(),
            this.menuConfig
        );
    },

    updateMenuView() {
        if (!MenuUtils.isComponentReady(this)) {
            setTimeout(() => this.updateMenuView(), 100);
            return;
        }

        const currentItems = this.getCurrentMenuItems();
        this.menuStructure.updateMenuComponents(currentItems);
    },

    getMenuLevel() {
        return MenuUtils.getMenuLevel(this.getAttributes());
    },

    reconstructTraitHierarchy() {
        const attributes = this.getAttributes();
        const menuLevels = MenuUtils.getMenuLevels(attributes);

        if (menuLevels.length <= 1) return;

        this.set('traits', []);
        this.buildTraitsSequentially(menuLevels, attributes, 0);
    },

    buildTraitsSequentially(menuLevels, attributes, levelIndex = 0) {
        if (levelIndex >= menuLevels.length) {
            setTimeout(() => {
                this.editor.trigger('component:selected', this);
                this.updateMenuView();
            }, 50);
            return;
        }

        const traitConfig = MenuUtils.createTraitConfig(
            menuLevels,
            attributes,
            levelIndex,
            this.menuConfig
        );

        this.addTrait(traitConfig);

        setTimeout(() => {
            this.buildTraitsSequentially(
                menuLevels,
                attributes,
                levelIndex + 1
            );
        }, 10);
    },
});
